import { ButtonLink, PlusIcon, Stack } from '@fukuri-admins/ui/common';
import { ROUTES } from '~/utils/routes';
import styles from './empty.module.scss';

/**
 * 社内報一覧の空状態コンポーネント
 */
export const InternalNewsListEmptyPresentation: React.FC = () => (
  <div className={styles.container}>
    <Stack gap={24} height='100%' alignItems='center' justifyContent='center'>
      <img
        src='/internal-news-empty.png'
        alt='社内報がまだありません'
        width={560}
        height={341}
        className={styles.illustration}
      />
      <Stack gap={16} alignItems='center' justifyContent='center'>
        <p className={styles.message}>作成済みの社内報はまだありません</p>
        <ButtonLink to={ROUTES.INTERNAL_NEWS.NEW} icon={<PlusIcon size='xs' />} iconPosition='left'>
          新規作成
        </ButtonLink>
      </Stack>
    </Stack>
  </div>
);
